import React from 'react';

export const stopPropagationCallback = (e: React.SyntheticEvent<any>) => {
    e.stopPropagation();
};
